module.exports = __webpack_public_path__ + "static/media/quote-bg.27ff3512.svg";